import BaseMessageHandler from '../BaseMessageHandler';
import { updateUser } from 'actions/user';

export default class Profile_UpdateTimezone extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    dispatch(updateUser(message.payload));
  };
}
